import {useEffect, useRef, useState} from "react";
import {API_URL} from "../../../constants/constants";
import {
    createProduct,
    deleteProduct,
    getCategories,
    getCollections,
    getProducts,
    updateProduct
} from "../../../api/api";
import { CrudTable } from "../crud_tables/crud_tables"
import {useTranslation} from "react-i18next";

export const ProductsSection = () => {
    const [products, setProducts] = useState<any[]>([])
    const [collections, setCollections] = useState<any[]>([]);
    const [categories, setCategories] = useState<any[]>([]);
    const [collectionId, setCollectionId] = useState<string>('');
    const [categoryId, setCategoryId] = useState<string>('');
    const [name, setName] = useState('');
    const [price, setPrice] = useState('');
    const [category, setCategory] = useState('');
    const [collection, setCollection] = useState('');
    const [image, setImage] = useState<File | null>(null);
    const [preview, setPreview] = useState<string | null>(null);
    const [editing, setEditing] = useState<any>(null);
    const [active, setActive] = useState<any>(true);
    const [sold, setSold] = useState<any>(false);
    const fileRef = useRef<HTMLInputElement>(null);
    const {t} = useTranslation()

    const load = () => getProducts().then(setProducts).catch(console.error);
    useEffect(() => {
            load()
            getCollections().then(setCollections).catch(console.error);
            getCategories().then(setCategories).catch(console.error); }
        ,[]);

    const handleImage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const f = e.target.files?.[0] || null;
        setImage(f);
        if (f) setPreview(URL.createObjectURL(f));
    };

    const reset = () => {
        setName(''); setPrice('');
        setCategory(''); setCollection('');
        setCollectionId(''); setCategoryId('');
        setImage(null); setPreview(null);
        setEditing(null);
        setActive(true);
        setSold(false); };

    const handleEdit = (row: any) => {
        setEditing(row);
        setName(row.name);
        setPrice(String(row.price));
        setCollectionId(row.collectionId ? String(row.collectionId) : '');
        setCategoryId(row.categoryId ? String(row.categoryId) : '');
        setActive(row.active);
        setSold(row.sold);
        setPreview(row.imageUrl ? `${API_URL}${row.imageUrl}` : null);
    };

    const handleSubmit = async () => {
        if (!name || !price) return;
        const fd = new FormData();
        fd.append('name', name);
        fd.append('price', price);
        fd.append('category', category);
        fd.append('categoryId', categoryId);
        fd.append('collection', collection);
        fd.append('collectionId', collectionId);
        fd.append('active', active ? 'true' : 'false');
        fd.append('sold', sold ? 'true' : 'false');
        if (image) fd.append('image', image);
        try {
            if (editing) {
                await updateProduct(editing.id, fd);
            } else {
                await createProduct(fd);
            }
            reset(); load();
        } catch (e) { console.error(e); }
    };

    const handleDelete = async (id: number) => {
        if (!window.confirm('Supprimer ce produit ?')) return;
        await deleteProduct(id);
        load();
    };

    return (
        <div>
            <div className="admin-card">
                <p className="admin-section-title" >{editing ? `${t("admin.products.edit-product")}`: `${t("admin.products.add-product")}`}</p>
                <div className="admin-form">
                    <div className="admin-field">
                        <label>{t("admin.products.product-name")}</label>
                        <input type="text" value={name} onChange={e => setName(e.target.value)} /></div>
                    <div className="admin-field">
                        <label>{t("admin.products.product-price")}</label>
                        <input type="number" value={price} onChange={e => setPrice(e.target.value)} /></div>
                    <div className="admin-field">
                        <label>{t("admin.products.active")}</label>
                        <input type="checkbox" checked={active} onChange={e => setActive(!active)} /></div>
                    <div className="admin-field">
                        <label>{t("admin.products.sold")}</label>
                        <input type="checkbox" checked={sold} onChange={e => setSold(!sold)} /></div>

                    <div className="admin-field">
                        <label>{t("admin.products.product-collection")}</label>
                        <select value={collectionId} onChange={e => setCollectionId(e.target.value)}>
                            <option value="">{t("admin.products.product-no-collection")}</option>
                            {collections.map(c => (
                                <option key={c.id} value={c.id}>{c.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="admin-field">
                        <label>{t("admin.products.product-category")}</label>
                        <select value={categoryId} onChange={e => setCategoryId(e.target.value)}>
                            <option value="">{t("admin.products.product-no-category")}</option>
                            {categories.map(c => (
                                <option key={c.id} value={c.id}>{c.name}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <div className="admin-upload-zone" onClick={() => fileRef.current?.click()}>
                            <input ref={fileRef} id="file-input" type="file" accept="image/*" onChange={handleImage}/>
                            {preview ? <div className="admin-preview"><img src={preview} alt="preview"/></div> :
                                <p>{t("admin.products.click-to-select-image")}</p>}
                        </div>
                    </div>
                    <div>
                        <button className="btn-admin btn-admin-primary"
                                onClick={handleSubmit}>{editing ? `${t("admin.products.update")}` : `${t("admin.products.save")}`}</button>
                        {editing && <button className="btn-admin btn-admin-secondary"
                                            onClick={reset}>{t("admin.products.cancel")}</button>}
                    </div>
                </div>
            </div>
            <div className="admin-card">
                <CrudTable cols={['id', 'name', 'price', 'active', 'sold', 'category', 'collection', 'imageUrl']} rows={products} onDelete={handleDelete} onEdit={handleEdit} />
            </div>
        </div>
    );
};
